import throttle from 'lodash-es/throttle'
import { useEffect, useState } from 'react'

export const useScrollRight = () => {
  const [isScrolledToRight, setIsScrolledToRight] = useState(false)
  const scroller: HTMLDivElement | null = document.querySelector('.dvn-scroller')
  const scrollerInner: HTMLDivElement | null = document.querySelector('.dvn-scroll-inner')

  useEffect(() => {
    if (!(scroller && scrollerInner)) {
      return
    }

    const handler = throttle(() => {
      const is = scroller.scrollWidth - scroller.clientWidth - scroller.scrollLeft < 2

      setIsScrolledToRight(is)
    }, 100)

    // Initial state: without this, a grid that doesn't overflow keeps the
    // "more columns to the right" affordance until the first scroll event.
    handler()

    const resizeObserver = new ResizeObserver(handler)
    resizeObserver.observe(scroller)

    scroller.addEventListener('scroll', handler)

    return () => {
      scroller.removeEventListener('scroll', handler)
      resizeObserver.disconnect()
    }
  }, [scroller, scrollerInner])

  return { isScrolledToRight, scroller }
}
